import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../app/config/Config";
import AppModel from "../../app/core/AppModel";
import BaseSaveModel from "../savegame/BaseSaveModel";
import SaveEvent from "../savegame/SaveEvent";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class MockPlatformAPIService extends PlatformAPIService {

    /**
     * @param {AppModel} appModel 
     * @param {BaseSaveModel} saveModel 
     * @param {Config} config 
     */
    constructor(appModel, saveModel, config, dispatcher) {
        super(appModel, saveModel);
        this._config = config;
        this._dispatcher = dispatcher;

        // Expose service to `window` object so its methods can be called via the Console.
        // NB: this can be useful to trigger the response duration, object and timeout state 
        // via the debug methods
        if(ranj.DEBUG) {
            window.mockApiService = this;
        }
    }

    initialize(version) {
        let isPlatformInterrupted = false;
        const mockConfiguration = {
            language: "en",
            interaction_state: this._load(),
            play_mode: "assessment",
            environment: this._config.getValue(Config.ENVIRONMENT),
        };

        this._version = version;

        this._responseObject = {
            statusCode: "201"
        };
        this._responseDelay = parseInt(getURLParameter('apitimeout') || 100);
        this._isTimeout = false;

        this._api = {
            getConfiguration: () => {
                return mockConfiguration;
            },

            getConfigurationAsync: () => {
                return new Promise(resolve => {
                    setTimeout(() => resolve(mockConfiguration), this._api.responseDelay);
                });
            },

            gameInterrupted: (payload) => {
                if(isPlatformInterrupted){
                    return true;
                }
                
                isPlatformInterrupted = true;
                alert(`Game interrupted by platform!\n\nReason:\n${JSON.stringify(payload, null, 2)}`);
                return true;
            },

            sendEvent: (eventType, payload) => {
                switch (eventType) {
                    case PlatformAPIEventType.SAVE_REQUEST:
                        this._save(payload.interaction_state);
                        break;
                }
                return true;
            },

            sendEventAsync: (eventType, payload) => {
                console.log(`[MockPlatformAPIService] sendEventAsync: `, eventType, payload || "no payload");
                switch (eventType) {
                    case PlatformAPIEventType.SAVE_REQUEST:
                        this._save(payload.interaction_state);
                        break;
                }
                return new Promise((resolve, reject) => setTimeout(_ => {
                    if(this._isTimeout) {
                        reject("MockAPI timeout");
                    } else {
                        resolve(this._responseObject);
                    }
                }, this.responseDelay));
            },

            exit: () => {
                this._dispatcher.dispatch(SaveEvent.CLEAR);
                window.location.reload();
            }
        }

        if (this.supportsGetConfigurationAsync()) {
            return this.getConfigurationAsync();
        } else {
            const platformParameters = this.getConfigurationSync();
            return Promise.resolve(platformParameters);
        }
    }

    setMockResponseObject(responseObject) {
        this._responseObject = responseObject;
    }

    setMockResponseDelay(responseDelay) {
        this._responseDelay = responseDelay;
    }

    setMockTimeoutState(isTimeout) {
        this._isTimeout = isTimeout;
    }

    _save(str) {
        window.localStorage.setItem(this._getCookieName(), str);
    }
    _load() {
        return window.localStorage.getItem(this._getCookieName());
    }
    _getCookieName() {
        return this._config.getValue(Config.APPID);
    }
}